import React from 'react';
import clsx from 'classnames';
import './index.css';
import QueueAnim from 'rc-queue-anim';

const ServiceSystem = () => {
  const systemList = [
    {
      title: '实验室建设',
      img: '/img/blurbSystem.png',
      textList: [
        '场地规划和设计',
        '设备及附件配置',
        '体系建设',
        '管理软件开发',
        '库房建设',
        '技术培训',
      ],
    },
    {
      title: '增值服务',
      img: '/img/blurbIncrement.png',
      textList: [
        '定制化解决方案',
        '技术咨询服务',
        '技术转让服务',
        '维护保养服务',
      ],
    },
    {
      title: '服务体系',
      img: '/img/blurbService.png',
      textList: ['科技项目合作', '标准编制', '实验室体系建设', '长期服务'],
    },
    {
      title: '服务宗旨',
      img: '/img/blurbPurpose.png',
      textList: [
        '质量第一',
        '责任至上',
        '贴身顾问',
        '高效快捷',
        '微笑服务',
        '用心服务',
      ],
    },
  ];

  return (
    <QueueAnim
      className={clsx('blurb-service-system')}
      type={['bottom', 'top']}
      delay={300}
    >
      <div
        className={clsx('blurb-service-system-title')}
        key='blurb-service-system-title'
      >
        服务体系
      </div>
      <div
        className={clsx('blurb-service-system-list')}
        key='blurb-service-system-list'
      >
        {systemList?.map((item, index) => {
          return (
            <div className={clsx('blurb-service-system-list-item')} key={index}>
              <div className={clsx('blurb-service-system-list-item-title')}>
                {item.title}
                <img src={item.img} alt='' width={'32%'} height={'32%'} />
              </div>
              <div className={clsx('blurb-service-system-list-item-text-list')}>
                {item.textList?.map((text, index) => {
                  return (
                    <div
                      className={clsx('blurb-service-system-list-item-text')}
                      key={index}
                    >
                      {text}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </QueueAnim>
  );
};

export default ServiceSystem;
